import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { QuickPoll } from "@/types";
import { fetchQuickPoll, saveQuickPoll } from "./thunk";

export interface QuickPollState {
  quickPoll: Partial<QuickPoll>;
  status: "idle" | "fetching" | "saving";
  answer: { optionId: null | number };
  error: string | null;
  viewResult: boolean;
}

const initialState: QuickPollState = {
  quickPoll: {},
  status: "idle",
  error: null,
  viewResult: false,
  answer: { optionId: null }
};

export const quickPollSlice = createSlice({
  name: "quickPoll",
  initialState,
  reducers: {
    toggleResult: (state) => {
      state.answer["optionId"] = null;
      state.viewResult = !state.viewResult;
    },
    updateQuickPoll: (state, action) => {
      state.error = null;
      state.answer["optionId"] = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[quickPollSlice.name]
      }))
      .addCase(fetchQuickPoll.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchQuickPoll.fulfilled, (state, action) => {
        state.status = "idle";
        state.quickPoll = action.payload;
      })
      .addCase(fetchQuickPoll.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      })
      .addCase(saveQuickPoll.pending, (state) => {
        state.status = "saving";
      })
      .addCase(saveQuickPoll.fulfilled, (state) => {
        state.status = "idle";
        state.viewResult = true;
      })
      .addCase(saveQuickPoll.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});

export const { toggleResult, updateQuickPoll } = quickPollSlice.actions;
